<div class="lk-panel">
  <div class="lk-panel__header">
    <h3 class="lk-panel__title">
      <i eIcon icon="lock-keyhole" family="solid"></i>
      {{ t('title') }}
    </h3>
    <div class="lk-panel__header-actions">
      <button
        eBtn
        size="xs"
        squared
        type="button"
        icon="table"
        color="highlight"
        iconColor="primary-75"
        [tooltip]="t('panel.globalCyclesButton')"
        data-test-id="locks-keys-global-cycles-button"
        (click)="openGlobalCyclesTable()"
      ></button>
      <button
        eBtn
        size="xs"
        squared
        type="button"
        icon="circle-info"
        color="highlight"
        iconColor="primary-75"
        [tooltip]="t('panel.introButton')"
        data-test-id="locks-keys-intro-button"
        (click)="openIntro()"
      ></button>
    </div>
  </div>

  <e-segmented-toggle
    block
    size="md"
    testId="locks-keys-scope"
    [groupLabel]="t('panel.scopeLabel')"
    [options]="scopeOptions()"
    [value]="state.scope()"
    (valueChange)="setScope($event)"
  ></e-segmented-toggle>

  <hd-locks-keys-period-pair-toggle playable></hd-locks-keys-period-pair-toggle>

  <button
    type="button"
    class="lk-compare-toggle"
    [class.is-active]="state.compare()"
    data-test-id="locks-keys-compare-toggle"
    (click)="toggleCompare()"
  >
    <i eIcon icon="table-columns" family="solid"></i>
    {{ t(state.compare() ? 'panel.compareToggleOff' : 'panel.compareToggle') }}
  </button>

  @if (showStatus()) {
    <div class="lk-summary" data-test-id="locks-keys-summary">
      {{ t(state.hasPartner() ? 'panel.activatedSummaryComposite' : 'panel.activatedSummary',
           { count: state.overview().activatedKeyCount }) }}
    </div>
    @if (personBadge(); as badge) {
      <div
        class="lk-person-badge"
        [attr.data-kind]="badge.kind"
        [attr.title]="badge.tooltip"
        data-test-id="locks-keys-person-badge"
      >
        <i eIcon icon="lock-keyhole" family="solid"></i>
        @if (badge.together) {
          <span class="lk-person-badge__together">{{ t('panel.personBadgeTogether') }}:</span>
        }
        <span class="lk-person-badge__label">{{ badge.label }}</span>
        <span class="lk-person-badge__counts">{{ badge.counts }}</span>
      </div>
    }
    @if (state.overview().activatedKeyCount === 0) {
      <div class="lk-summary lk-summary--muted">{{ t('panel.chartNoKeysHint') }}</div>
    }
  } @else {
    <div class="lk-summary lk-summary--muted">{{ t('panel.generalHint') }}</div>
  }

  @for (group of groups(); track group.key) {
    <section class="lk-group">
      <h4 class="lk-group__title">
        <span class="lk-dot" [class.lk-dot--vessel]="group.key === 'vessel'" [class.lk-dot--sphinx]="group.key === 'sphinx'"></span>
        {{ group.label }}
        <span class="lk-group__key-cross">
          <span class="lk-dot" [class.lk-dot--keys-equinox]="group.keysAreEquinox" [class.lk-dot--keys-counter]="!group.keysAreEquinox"></span>
          {{ group.keyCrossName }}
        </span>
      </h4>
      <table class="lk-table">
        <thead>
          <tr>
            <th class="lk-table__lock-col">{{ t('panel.lockHeader') }}</th>
            <th class="lk-table__keys-col">{{ t('panel.keysHeader') }}</th>
            @if (showStatus()) {
              <th class="lk-table__status-col">{{ t('panel.statusHeader') }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of group.rows; track row.lockGate) {
            <tr
              class="lk-row"
              [attr.title]="t('panel.lockRowTooltip')"
              [attr.data-test-id]="'locks-keys-row-' + row.lockGate"
              (click)="openLockDetail(row.lockGate)"
            >
              <td class="lk-row__lock">
                <span class="lk-lock-chip">
                  <i eIcon icon="lock" family="solid"></i>
                  {{ row.lockGate }}
                </span>
                @if (row.lockPlanets.length > 0) {
                  <span
                    class="lk-lock-planets"
                    [attr.title]="t('detail.lockActivatedBy', { gate: row.lockGate })"
                  >
                    @for (planet of row.lockPlanets; track planet.key) {
                      <span class="lk-planet" [style.color]="planet.color">{{ planet.glyph }}</span>
                    }
                  </span>
                }
                <span class="lk-row__role-wrap">
                  <span class="lk-row__role" [attr.title]="row.theme">{{ row.role }}</span>
                  @if (row.roleQualifier) {
                    <span class="lk-row__role-qualifier">{{ row.roleQualifier }}</span>
                  }
                </span>
              </td>
              <td class="lk-row__keys">
                <span
                  class="lk-key"
                  [class.is-active]="state.activeSlot() === 0"
                >{{ row.pairKeyGates[0] }}</span>
                <i eIcon icon="arrow-right" family="solid" class="lk-key-arrow"></i>
                <span
                  class="lk-key"
                  [class.is-active]="state.activeSlot() === 1"
                >{{ row.pairKeyGates[1] }}</span>
              </td>
              @if (showStatus()) {
                <td class="lk-row__status" [attr.title]="keyStatusTooltip(row)">
                  @if (row.keyActivated) {
                    <span class="lk-planets">
                      @for (planet of row.keyPlanets; track planet.key) {
                        <span class="lk-planet" [style.color]="planet.color">{{ planet.glyph }}</span>
                      }
                    </span>
                  } @else {
                    <i eIcon icon="key" family="solid" class="lk-key-missing"></i>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </section>
  }

  <!-- Composite/relatie: cross-persoon slot-sleutelrelatie (welke sleutel van
       de één een slot van de ander opent), met pre/post-2027 toggle die default
       de nú geldende periode toont. Enkel bij een geladen partner. -->
  @if (state.hasPartner()) {
    <section class="lk-relationship" data-test-id="locks-keys-relationship">
      <h4 class="lk-relationship__title">
        <i eIcon icon="link" family="solid"></i>
        {{ t('panel.relTitle') }}
      </h4>
      <p class="lk-relationship__hint">{{ t('panel.relHint') }}</p>
      @if (relationshipRows().length > 0) {
        <ul class="lk-relationship__list">
          @for (row of relationshipRows(); track row.id) {
            <li class="lk-relationship__item">
              <span class="lk-relationship__party">
                <span class="lk-relationship__lead">
                  <span class="lk-relationship__person" [style.color]="row.left.color">{{ row.left.name }}</span>
                  @for (holding of row.left.holdings; track holding.kind) {
                    <span class="lk-relationship__flag" [attr.data-kind]="holding.kind">
                      <i eIcon [icon]="holding.kind === 'key' ? 'key' : 'lock'" family="solid"></i>{{ holding.gateText }}
                    </span>
                  }
                </span>
                @for (holding of row.left.holdings; track holding.kind) {
                  @if (holding.keynote) {
                    <span class="lk-relationship__keynote">{{ holding.keynote }}</span>
                  }
                }
              </span>
              <i
                eIcon
                [icon]="row.direction === 'both' ? 'arrow-right-arrow-left' : 'arrow-right'"
                family="solid"
                class="lk-relationship__arrow"
              ></i>
              <span class="lk-relationship__party">
                <span class="lk-relationship__lead">
                  <span class="lk-relationship__person" [style.color]="row.right.color">{{ row.right.name }}</span>
                  @for (holding of row.right.holdings; track holding.kind) {
                    <span class="lk-relationship__flag" [attr.data-kind]="holding.kind">
                      <i eIcon [icon]="holding.kind === 'key' ? 'key' : 'lock'" family="solid"></i>{{ holding.gateText }}
                    </span>
                  }
                </span>
                @for (holding of row.right.holdings; track holding.kind) {
                  @if (holding.keynote) {
                    <span class="lk-relationship__keynote">{{ holding.keynote }}</span>
                  }
                }
              </span>
            </li>
          }
        </ul>
      } @else {
        <p class="lk-relationship__none">{{ t('panel.relNone') }}</p>
      }
    </section>
  }

  <!-- Zoektocht in de bibliotheek: charts met een lock/key-relatie met deze
       chart in de gekozen periode (verbergt zich buiten de chart-pagina en
       op een composite-tab). -->
  <hd-locks-keys-chart-search></hd-locks-keys-chart-search>

  <!-- Legende + ster-checkboxes onderaan (bijstuurronde 2): de vier
       kruis-tinten van de 8-puntige ster — geel-varianten = lock-kruisen,
       blauw-varianten = key-kruisen van de actieve periode. -->
  <div class="lk-legend">
    <!-- Locks & keys op de bodygraph (spec 2026-10-10): zelfde drie-standen-
         toggle als in het Geavanceerd-paneel; zinvol zodra de mandala uit staat. -->
    <div class="lk-legend__row">
      <hd-locks-keys-overlay-toggle />
    </div>
    <div class="lk-legend__row">
      <button
        type="button"
        class="lk-legend__toggle"
        [class.is-active]="state.showLocksStar()"
        [attr.aria-pressed]="state.showLocksStar()"
        data-test-id="locks-keys-star-locks-toggle"
        (click)="toggleLocksStar()"
      >
        <span class="lk-legend__checkbox">
          @if (state.showLocksStar()) {
            <i eIcon icon="check" family="solid"></i>
          }
        </span>
        {{ t('legend.locksStar') }}
      </button>
      <span class="lk-legend__item">
        <span class="lk-dot lk-dot--vessel"></span>{{ t('detail.groupVessel') }}
      </span>
      <span class="lk-legend__item">
        <span class="lk-dot lk-dot--sphinx"></span>{{ t('detail.groupSphinx') }}
      </span>
    </div>
    <div class="lk-legend__row">
      <button
        type="button"
        class="lk-legend__toggle lk-legend__toggle--keys"
        [class.is-active]="state.showKeysStar()"
        [attr.aria-pressed]="state.showKeysStar()"
        data-test-id="locks-keys-star-keys-toggle"
        (click)="toggleKeysStar()"
      >
        <span class="lk-legend__checkbox">
          @if (state.showKeysStar()) {
            <i eIcon icon="check" family="solid"></i>
          }
        </span>
        {{ t('legend.keysStar') }}
      </button>
      @for (item of keysStarLegend(); track item.equinox) {
        <span class="lk-legend__item">
          <span class="lk-dot" [class.lk-dot--keys-equinox]="item.equinox" [class.lk-dot--keys-counter]="!item.equinox"></span>{{ item.crossName }}
        </span>
      }
    </div>
    @if (state.showLocksStar() || state.showKeysStar()) {
      <div class="lk-legend__row" data-test-id="locks-keys-legend-equinox">
        <span class="lk-legend__item" [attr.title]="t('legend.equinoxTooltip')">
          <span class="lk-line lk-line--equinox"></span>{{ t('legend.equinox') }}
        </span>
      </div>
    }
    <p class="lk-legend__note">{{ t('legend.orderNote') }}</p>
  </div>
</div>
